const messages = {
  en: {
    title: "Shows App",
    coppyrigh: "Shows App",
    shows: "SHOWS",
    notFind: "No Items here :(",
    watchlistTitle: "Watchlist",
    watchedTitle: "Watched Shows",
    home: "HOME",
    loadMore: "Load More",
    noImage: "No image available",
    markWatched: "Mark as watched",
    markToWatch: "Add to watchlist",
    markWatchedRemove: "Remove from watched",
    markToWatchRemove: "Remove from watchlist",
    search: "Search",
    pageNotFound: "Page Not Found",
    pageNotFoundDesc: "The page you are looking for does not exist",
    subscribeTitle: "Subscribe on genre update",
    name: "Name",
    email: "E-mail",
    geners: "Genres",
    messageForm: "Message",
    acceptNews: "Send me another news",
    dismissNews: "Don`t send me another news",
    formCheckbox: "I agree to the processing of personal data",
    buttonSubmit: "SUBMIT",
    formModalHeadline: "Confirmation",
    formModalTitle: "Are you sure you want to submit the form?",
    date: "Date",
    confirm: "Confirm",
    cancel: "Cancel",
    formSubmittedSuccessfully: "Form submitted successfully",
    permissionTitle: "Choose user permission",
    permissionLang: "Changing the language and theme",
    permissionBtnOn: "Enable All",
    permissionBtnOff: "Disable All",
    changeLangState: "Change Language",
    changeThemeState: "Change Theme",
    sendFormState: "Send Form",
    addToWatchedState: "Add to Watched",
    addToWatchlistState: "Add to Watchlist",
    permissionText: "Permission",
    permissionTextTwo: "Allowed",
  },
  uk: {
    title: "Додаток з серіалами",
    coppyrigh: "Додаток з серіалами",
    shows: "Серіали",
    notFind: "Нічого тут нема :(",
    watchlistTitle: "До перегляду",
    watchedTitle: "Переглянуті серіали",
    home: "НА ГОЛОВНУ",
    loadMore: "Завантажити ще",
    noImage: "Немає картинки",
    markWatched: "Відмітити як переглянутий",
    markToWatch: "Додати до перегляду",
    markWatchedRemove: "Видалити з переглянутих",
    markToWatchRemove: "Видалити з до перегляду",
    search: "Пошук",
    pageNotFound: "Сторінку не знайдено",
    pageNotFoundDesc: "Сторінка, яку ви шукаєте, не існує",
    subscribeTitle: "Підписатись на оновлення категорій",
    name: "Ім'я",
    email: "Пошта",
    geners: "Жанри",
    messageForm: "Повідомлення",
    acceptNews: "Надсилати мені інші новини",
    dismissNews: "Не надсилати мені інші новини",
    formCheckbox: "Я згоден на обробку персональних данних",
    buttonSubmit: "ВІДПРАВИТИ",
    formModalHeadline: "Підтвердження",
    formModalTitle: "Ви впевненні, що бажаєте надіслати форму?",
    date: "Дата",
    confirm: "Підтвердити",
    cancel: "Скасувати",
    formSubmittedSuccessfully: "Форму успішно надіслано",
    permissionTitle: "Вибір доступів користувача",
    permissionLang: "Зміна мови та теми",
    permissionBtnOn: "Ввімкнути все",
    permissionBtnOff: "Вимкнути все",
    changeLangState: "Зміна мови",
    changeThemeState: "Зміна теми",
    sendFormState: "Відправка форми",
    addToWatchedState: "Додававння в 'переглянуті'",
    addToWatchlistState: "Додававння в 'до перегляду'",
    permissionText: "Доступи",
    permissionTextTwo: "Дозволено",
  },
};

export default messages;
